import { Bar, mixins } from "vue-chartjs";
const {getImageURL} = require("@/components/General/utils")
export default {
  name: "bar-chart",
  extends: Bar,
  props: {
    chartData: {
      type: Object,
    },
    extraOptions: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mixins: [mixins.reactiveProp],
  mounted() {
    this.$watch(
      "chartData",
      (newVal) => {
        if (newVal && newVal.length) {
          this.renderChart(newVal, this.extraOptions);
        }
      },
      { immediate: true }
    );

    this.$watch(
      "extraOptions",
      (newVal) => {
        if (newVal && newVal.length) {
          // console.log(extraOptions);
          this._chart.destroy();
          this.renderChart(this.chartData, newVal);
        }
      },
      { immediate: true }
    );

    this.addPlugin({
      id: "image-label",
      afterDraw: (chart) => {
        var ctx = chart.chart.ctx;
        var xAxis = chart.scales["x-axis-0"];
        var yAxis = chart.scales["y-axis-0"];
        xAxis.ticks.forEach((value, index) => {
          var x = xAxis.getPixelForTick(index);
          let images = this.chartData.images;
          if (images && images[index]) {
            var image = new Image();
            image.src = getImageURL(images[index].file)
            image.onload = function(){
              ctx.drawImage(
                image,
                x - images[index].width / 2,
                yAxis.bottom + 20,
                images[index].width,
                images[index].height
              );
            }   
          }
        });
      },
    });

    this.addPlugin({
      id: "click-event",
      afterEvent: (chart, args) => {
        if (args.type == "click") {
          var yTop = chart.chartArea.top;
          var yBottom = chart.chartArea.bottom;

          var yMin = chart.scales["y-axis-0"].min;
          var yMax = chart.scales["y-axis-0"].max;

          var newY = 0;
          if (args.native.offsetY <= yBottom && args.native.offsetY >= yTop) {
            newY = Math.abs((args.native.offsetY - yTop) / (yBottom - yTop));
            newY = (newY - 1) * -1;
            newY = newY * Math.abs(yMax - yMin) + yMin;
          }

          var xTop = chart.chartArea.left;
          var xBottom = chart.chartArea.right;
          // var xMin = chart.scales["x-axis-0"].min;
          // var xMax = chart.scales["x-axis-0"].max;
          var xMin = 0;
          var xMax = this.chartData.labels.length - 1;
          var newX = 0;

          if (args.native.offsetX <= xBottom && args.native.offsetX >= xTop) {
            newX = Math.abs((args.native.offsetX - xTop) / (xBottom - xTop));
            newX = newX * Math.abs(xMax - xMin) + xMin;
          }
          let stepY = this.extraOptions.scales.yAxes[0].ticks.stepSize;

          for (let i = 0; i <= this.chartData.bars.length - 1; i++) {
            // console.log(i, Math.round(newX))
            if (
              Math.round(newX) == i &&
              this.chartData.bars[i].is_user_select_points
            ) {
              this.$emit("data", {
                index: Math.round(newX),
                value: Math.round(newY / stepY) * stepY,
              });

              this.chartData.datasets[0].data[Math.round(newX)] = Math.round(
                Math.round(newY / stepY) * stepY
              );
              this.renderChart(this.chartData, this.extraOptions);
            }
          }
        }
      },
    });

    this.renderChart(this.chartData, this.extraOptions);
  },
};
